export const SpacesAvailableModeEnum = Object.freeze({
    MIN: 'min', // At least this quantity is available.
    EXACT: 'exact',
});
